import React from 'react';
import Loadable from 'react-loadable'
import DefaultLayout from './containers/DefaultLayout';
import EditProduct from "./views/Product/EditProduct";
import GoogleOAuthView from "./views/GoogleOauth/GoogleOAuthView";
import GoogleOAuthConfigView from "./views/GoogleOauth/GoogleOAuthConfigView";

function Loading({error}) {
  if (error) {
    return <div className={'text-danger'}>An error occurred while displaying: {error.toString()}</div>
  }
  return <div>Loading...</div>;
}

const Dashboard = Loadable({
  loader: () => import('./views/Dashboard/Dashboard'),
  loading: Loading,
});

const Users = Loadable({
  loader: () => import('./views/Users/Users'),
  loading: Loading,
});

const User = Loadable({
  loader: () => import('./views/Users/User'),
  loading: Loading,
});

const Catalog = Loadable({
  loader: () => import('./views/Product/Catalog/Catalog'),
  loading: Loading,
});

const ProductTemplates = Loadable({
  loader: () => import('./views/Product/Templates'),
  loading: Loading,
});

const OutputRunsPage = Loadable({
  loader: () => import('./views/Retailer/Templates/OutputRunsPage'),
  loading: Loading,
})

const OutputDetailView = Loadable({
  loader: () => import('./views/Retailer/Templates/OutputDetailView'),
  loading: Loading,
})

const SpecificOutputRunPage = Loadable({
  loader: () => import('./views/Retailer/Templates/specificOutputRunPage/SpecificOutputRunPage'),
  loading: Loading,
})

const ShopifyGqlToolPage = Loadable({
  loader: () => import('./views/Retailer/Templates/ShopifyGqlTool/ShopifyGqlToolPage'),
  loading: Loading,
})

const SimulateExtractDataWithAiPage = Loadable({
  loader: () => import('./views/Tools/SimulateExtractDataWithAiPage'),
  loading: Loading,
})


const IntegrationTemplates = Loadable({
  loader: () => import('./views/IntegrationTemplates/IntegrationTemplates'),
  loading: Loading,
});

const DataPoints = Loadable({
  loader: () => import('./views/Product/DataPoints/ListDataPoints/ListDataPoints'),
  loading: Loading,
});

const DataPointDetails = Loadable({
  loader: () => import('./views/Product/DataPoints/DataPointDetails/DataPointDetails'),
  loading: Loading,
});

const AddProductTemplate = Loadable({
  loader: () => import('./views/Product/AddTemplate'),
  loading: Loading,
});

const EditProductTemplate = Loadable({
  loader: () => import('./views/Product/EditTemplate/EditTemplate'),
  loading: Loading,
});

const ProductTemplateDataPointConfiguration = Loadable({
  loader: () => import('./views/Product/EditTemplate/DataPointsConfiguration'),
  loading: Loading
});

const ProductTemplateEnrichments = Loadable({
  loader: () => import('./views/Product/EditTemplate/EnrichmentsTab'),
  loading: Loading
})

const DetailedProductViewConfigTab = Loadable({
  loader: () => import('./views/Product/EditTemplate/DetailedProductViewConfigurations'),
  loading: Loading
})

const MeaningsTab = Loadable({
  loader: () => import('./views/Product/EditTemplate/MeaningsTab/MeaningsTab'),
  loading: Loading
})

const FieldDependencyConfig = Loadable({
  loader: () => import('./views/Product/EditTemplate/FieldDependencyConfig/FieldDependencyConfig'),
  loading: Loading
})

const Companies = Loadable({
  loader: () => import('./views/Company/Companies/Companies'),
  loading: Loading,
})

const Brands = Loadable({
  loader: () => import('./views/UsersOverview/BrandsOverview/BrandsOverviewPage'),
  loading: Loading,
});

const Brand = Loadable({
  loader: () => import('./views/Brand/Brand'),
  loading: Loading,
});

const ProductMappingConfig = Loadable({
  loader: () => import('./views/Product/ProdMappingConf/ProdMappingConfig'),
  loading: Loading,
});

const RetailerList = Loadable({
  loader: () => import('./views/UsersOverview/RetailersOverview/RetailersOverviewPage'),
  loading: Loading,
})

const RetailerView = Loadable({
  loader: () => import('./views/Retailer/RetailerView/RetailerView'),
  loading: Loading
})

const RetailerTemplates = Loadable({
  loader: () => import('./views/Retailer/Templates/RetailerDistributeDataTemplates'),
  loading: Loading,
});

const RetailerDistributeDataTemplateMappingConfig = Loadable({
  loader: () => import('./views/Retailer/TemplateMappingConfig/TemplateMappingConfig'),
  loading: Loading,
});

const RetailerDistributeDataTemplate = Loadable({
  loader: () => import('./views/Retailer/DistributeDataTemplate/DistributeDataTemplate'),
  loading: Loading,
});


const UniqueAttributes = Loadable({
  loader: () => import('./views/Product/UniqueAttributes/UniqueAttributes'),
  loading: Loading,
});

const UniqueAttribute = Loadable({
  loader: () => import('./views/Product/UniqueAttributes/UniqueAttribute'),
  loading: Loading,
});

const UniqueValues = Loadable({
  loader: () => import('./views/UniqueValues/UniqueValuesListView'),
  loading: Loading,
})

const UniqueValueSet = Loadable({
  loader: () => import('./views/UniqueValues/UniqueValueSetDetailsView'),
  loading: Loading,
})

const CompleteMissingValues = Loadable({
  loader: () => import('./views/ImportRuns/CompleteMissingValuesPage'),
  loading: Loading
})

const ManualInputHints = Loadable({
  loader: () => import('./views/ManualInputHints/ManualInputHintsPage'),
  loading: Loading
})

const IngestedFiles = Loadable({
  loader: () => import('./views/IngestedFiles/IngestedFileListView'),
  loading: Loading,
})

const SingleIngestedFile = Loadable({
  loader: () => import('./views/IngestedFiles/SingleIngestedFileView'),
  loading: Loading,
})

const IngestionChannels = Loadable({
  loader: () => import('./views/IngestionChannels/IngestionChannelListView'),
  loading: Loading
})

const IngestionRunPage = Loadable({
  loader: () => import('./views/IngestionRun/IngestionRunPage'),
  loading: Loading
})

const CreateIngestionChannel = Loadable({
  loader: () => import('./views/IngestionChannels/CreateIngestionChannelView'),
  loading: Loading
});

const ViewIngestionChannel = Loadable({
  loader: () => import("./views/IngestionChannels/IngestionChannelView"),
  loading: Loading
});

const ViewIngestionChannelRuns = Loadable({
  loader: () => import("./views/IngestionChannels/IngestionChannelRunsView"),
  loading: Loading
})

const ViewIngestionChannelReprocessTriggers = Loadable({
  loader: () => import("./views/IngestionChannels/IngestionChannelAutomaticReprocessingView"),
  loading: Loading
})

const ViewIngestionChannelTriggers = Loadable({
  loader: () => import("./views/IngestionChannels/IngestionChannelTriggersView"),
  loading: Loading
})

const ViewIngestionChannelOutputTriggersView = Loadable({
  loader: () => import("./views/IngestionChannels/IngestionChannelOutputTriggersView"),
  loading: Loading
})

const ViewIngestionChannelRelatedBrandsRetailers = Loadable({
  loader: () => import("./views/IngestionChannels/IngestionChannelRelatedBrandsRetailersView"),
  loading: Loading
})

const ViewIngestionChannelMatching = Loadable({
  loader: () => import("./views/IngestionChannels/IngestionChannelMatchingView"),
  loading: Loading
})

const InputTemplateListView = Loadable({
  loader: () => import("./views/inputTemplates/InputTemplateListView"),
  loading: Loading
})


const InputFlowListView = Loadable({
  loader: () => import("./views/InputFlows/InputFlowListView"),
  loading: Loading,
})

const OrderListView = Loadable({
  loader: () => import('./views/Orders/OrderList/OrderListView'),
  loading: Loading
})

const OrderSharingPolicies = Loadable({
  loader: () => import('./views/OrderSharingPolicies/OrderSharingPoliciesList'),
  loading: Loading
})

const OrderSharingPolicyPage = Loadable({
  loader: () => import('./views/OrderSharingPolicies/OrderSharingPolicyPage'),
  loading: Loading
})

const OCParsers = Loadable({
  loader: () => import('./views/OCParsers/OCParsers'),
  loading: Loading
})

const OrderDetailsView = Loadable({
  loader: () => import('./views/Orders/OrderView/OrderView'),
  loading: Loading
})

const DeliveryNotesListPage = Loadable({
  loader: () => import('./views/DeliveryNotes/DeliveryNotesList/DeliveryNotesListPage'),
  loading: Loading,
});

const DeliveryNoteItemsListPage = Loadable({
  loader: () => import('./views/DeliveryNotes/DeliveryNoteItemsList/DeliveryNoteItemsListPage'),
  loading: Loading,
});

const DataPullListView = Loadable({
  loader: () => import('./views/DataPulls/DataPullList'),
  loading: Loading
})

const DataPullDetailedView = Loadable({
  loader: () => import('./views/DataPulls/DataPullDetailedView'),
  loading: Loading
})

const DataPullRunDetailedView = Loadable({
  loader: () => import('./views/DataPullRuns/DataPullRunDetailsView'),
  loading: Loading,
})

const WebhookListView = Loadable({
  loader: () => import('./views/Webhooks/WebhookList'),
  loading: Loading
})

const WebhookDetailedView = Loadable({
  loader: () => import('./views/Webhooks/WebhookDetailedView'),
  loading: Loading
})

const PipelineListView = Loadable({
  loader: () => import('./views/Pipelines/PipelineListView'),
  loading: Loading
})

const TaskQueueStatsPage = Loadable({
  loader: () => import('./views/TaskQueueStats/TaskQueueStatsPage'),
  loading: Loading,
})

const ClusterJobsOverviewPage = Loadable({
  loader: () => import('./views/ClusterJobsOverview/ClusterJobsOverviewPage'),
  loading: Loading,
})

const DevSnapshots = Loadable({
  loader: () => import('./views/DevSnapshots/DevSnapshotsPage'),
  loading: Loading
})

const AmazonMarketplace = Loadable({
  loader: () => import('./views/Amazon/AmazonMarketplaces'),
  loading: Loading
})

const ShopifyClientCredsOverrides = Loadable({
  loader: () => import('./views/Shopify/ShopifyClientCredsOverrides'),
  loading: Loading
})

const BolMarketplaces = Loadable({
  loader: () => import('./views/Bol/BolMarketplaces'),
  loading: Loading
})

const BolMarketplaceView = Loadable({
  loader: () => import('./views/Bol/BolMarketplaceView'),
  loading: Loading
})

const BolProductTypeView = Loadable({
  loader: () => import('./views/Bol/BolProductTypeView'),
  loading: Loading,
})


const EdiMain = Loadable({
  loader: () => import('./views/edi/EdiMain'),
  loading: Loading,
})

const EdiConfiguration = Loadable({
  loader: () => import('./views/edi/EdiConfiguration'),
  loading: Loading,
})


const EdiMessages = Loadable({
  loader: () => import('./views/edi/EdiMessages'),
  loading: Loading,
})

const DirectOutputsListPage = Loadable({
  loader: () => import('./views/DirectOutputsList/DirectOutputListPage'),
  loading: Loading,
})


const DirectOutputDetailsPage = Loadable({
  loader: () => import('./views/DirectOutputDetails/DirectOutputDetailsPage'),
  loading: Loading,
})

const SalesDataPushPipelinesPage = Loadable({
  loader: () => import('./views/SalesDataPushPipelines/SalesDataPushPipelinesPage'),
  loading: Loading,
})

const SalesDataPushRunsPage = Loadable({
  loader: () => import('./views/SalesDataPushRuns/SalesDataPushRunsPage'),
  loading: Loading,
})

const InventoryDataPushPipelinesPage = Loadable({
  loader: () => import('./views/InventoryDataPushPipelines/InventoryDataPushPipelinesPage'),
  loading: Loading,
})

const InventoryDataPushRunsPage = Loadable({
  loader: () => import('./views/InventoryDataPushRuns/InventoryDataPushRunsPage'),
  loading: Loading,
})


const MagasinFtpProcessingPage = Loadable({
  loader: () => import('./views/MagasinFtpProcessing/MagasinFtpProcessingPage'),
  loading: Loading,
})

const MagasinFtpRootPage = Loadable({
  loader: () => import('./views/MagasinFtpProcessing/MagasinRootPage'),
  loading: Loading,
})

const BusinessIntelligencePage = Loadable({
  loader: () => import('./views/BusinessIntelligence/BusinessIntelligencePage'),
  loading: Loading,
})

const BusinessIntelligenceRunStatesPage = Loadable({
  loader: () => import('./views/BusinessIntelligence/RunStatesPage'),
  loading: Loading,
})

const BusinessIntelligenceEosKpisPage = Loadable({
  loader: () => import('./views/BusinessIntelligence/EosKpis/EosKpisPage'),
  loading: Loading,
});

const BusinessIntelligenceAiUsagePage = Loadable({
  loader: () => import('./views/BusinessIntelligence/AiUsagePage'),
  loading: Loading,
})

const MagasinFtpUsage = Loadable({
  loader: () => import('./views/MagasinFtpProcessing/MagasinUsage'),
  loading: Loading,
})

const MagasinToolSingleImageProcessing = Loadable({
  loader: () => import('./views/MagasinFtpProcessing/MagasinToolSingleImageProcessing'),
  loading: Loading,
})

const MagasinHistory = Loadable({
  loader: () => import('./views/MagasinFtpProcessing/MagasinHistory'),
  loading: Loading,
})

const ReportsListPage = Loadable({
  loader: () => import('./views/Reports/ReportsListPage'),
  loading: Loading,
})

const ReportDetailsPage = Loadable({
  loader: () => import('./views/Reports/ReportDetailsPage'),
  loading: Loading,
})

const BarcodeMetricsPage = Loadable({
  loader: () => import('./views/SalesAndInventoryData/BarcodeMetricsPage'),
  loading: Loading,
})

const SystemSettingsPage = Loadable({
  loader: () => import('./views/System/SystemSettingsPage'),
  loading: Loading,
})

// https://github.com/ReactTraining/react-router/tree/master/packages/react-router-config
const routes = [
  {path: '/', exact: true, name: 'Home', component: DefaultLayout},
  {path: '/dashboard', exact: true, name: 'Dashboard', component: Dashboard},
  {path: '/users/:id', exact: true, name: 'User details', component: User},
  {path: '/users', exact: true, name: 'Users', component: Users},
  {path: '/system/settings', exact: true, name: 'System settings', component: SystemSettingsPage},
  // kept so the old bookmarks keep working
  {path: '/system/feature-flags', exact: true, name: 'System settings', component: SystemSettingsPage},
  {path: '/product', exact: true, name: 'Product', component: Catalog},
  {path: '/product/catalog', exact: true, name: 'Catalog', component: Catalog},
  //{path: '/product/create', exact: true, name: 'Create new product', component: CreateProduct},
  {path: '/product/catalog/editProduct/:productId/', exact: true, name: 'Product', component: EditProduct},
  {path: '/product/catalog/editProduct/:productId/:groupPath', name: "", exact: true, component: EditProduct},
  {path: '/product/templates', exact: true, name: 'RetailerDistributeDataTemplates', component: ProductTemplates},
  {path: '/retailer/integrations', exact: true, name: 'IntegrationTemplates', component: IntegrationTemplates},
  {path: '/product/data-points/:id', exact: true, name: 'Data Point Details', component: DataPointDetails},
  {path: '/product/data-points', exact: true, name: 'Data Points', component: DataPoints},
  {path: '/product/uniqueattributes', exact: true, name: 'Unique Attributes', component: UniqueAttributes},
  {path: '/product/uniqueattributes/:id', exact: true, name: 'Unique Attribute', component: UniqueAttribute},
  {path: '/system/unique-values/', exact: true, name: 'Unique Value Sets', component: UniqueValues},
  {path: '/system/unique-values/:id/:tab', exact: true, name: 'Unique Value Set Details', component: UniqueValueSet},
  {path: '/system/ingestion-channels', exact: true, name: 'Ingestion channels', component: IngestionChannels},
  {path: '/system/ingestion-runs/:id', exact: true, name: 'Ingestion run', component: IngestionRunPage},
  {path: '/system/amazon/marketplaces', exact: true, name: 'Amazon Marketplace', component: AmazonMarketplace},
  {
    path: '/system/amazon/marketplaces/:marketplaceId',
    exact: true,
    name: 'Amazon Marketplace',
    component: AmazonMarketplace
  },
  {
    path: '/system/amazon/marketplaces/:marketplaceId/:templateId',
    exact: true,
    name: 'Amazon Marketplace',
    component: AmazonMarketplace
  },
  {path: '/system/shopify/client-creds-overrides', exact: true, name: 'Shopify Client Creds Overrides', component: ShopifyClientCredsOverrides},
  {path: '/system/bol/marketplaces/', exact: true, name: 'Bol.com Marketplace', component: BolMarketplaces},
  {
    path: '/system/bol/marketplaces/:country',
    exact: true,
    name: 'Bol.com Language Marketplace',
    component: BolMarketplaceView
  },
  {
    path: '/system/bol/marketplaces/:country/:chunkId',
    exact: true,
    name: 'Bol.com Chunk',
    component: BolProductTypeView
  },

  {
    path: '/system/ingestion-channels/create',
    exact: true,
    name: 'Create ingestion channel',
    component: CreateIngestionChannel
  },
  {
    path: '/system/ingestion-channels/:id',
    exact: true,
    name: 'Ingestion channel view',
    component: ViewIngestionChannel
  },
  {
    path: '/system/ingestion-channels/:id/runs',
    exact: true,
    name: 'Ingestion channel runs',
    component: ViewIngestionChannelRuns
  },
  {
    path: '/system/ingestion-channels/:id/automatic-reprocessing',
    exact: true,
    name: 'Ingestion channel automatic reprocessing',
    component: ViewIngestionChannelReprocessTriggers,
  },
  {
    path: '/system/ingestion-channels/:id/triggers',
    exact: true,
    name: 'Ingestion channel triggers',
    component: ViewIngestionChannelTriggers
  }, {
    path: '/system/ingestion-channels/:id/output-triggers',
    exact: true,
    name: 'Ingestion channel triggers',
    component: ViewIngestionChannelOutputTriggersView
  },
  {
    path: '/system/ingestion-channels/:id/related-brands-retailers',
    exact: true,
    name: 'Ingestion channel related brands and retailers',
    component: ViewIngestionChannelRelatedBrandsRetailers
  },
  {
    path: '/system/ingestion-channels/:id/matching',
    exact: true,
    name: 'Ingestion channel matching',
    component: ViewIngestionChannelMatching
  },
  {path: '/input/input-flows', exact: true, name: 'Input flows', component: InputFlowListView},
  {path: '/system/ingested-files', exact: true, name: 'Ingested files', component: IngestedFiles},
  {path: '/system/ingested-files/:id', exact: true, name: 'Ingested file', component: SingleIngestedFile,},
  {path: '/system/data-pulls', exact: true, name: 'Data pulls', component: DataPullListView,},
  {path: '/system/data-pulls/:id', exact: true, name: 'Data pull', component: DataPullDetailedView,},
  {path: '/system/data-pulls/:id/:tab', exact: true, name: 'Data pull', component: DataPullDetailedView,},
  {path: '/system/data-pull-runs/:id', exact: true, name: 'Data pull run', component: DataPullRunDetailedView,},
  {path: '/system/webhooks', exact: true, name: 'Webhooks', component: WebhookListView,},
  {path: '/system/webhooks/:id', exact: true, name: 'Webhook', component: WebhookDetailedView,},
  {path: '/system/webhooks/:id/:tab', exact: true, name: 'Webhook', component: WebhookDetailedView,},
  {path: '/product/templates/addTemplate', exact: true, name: 'Add Template', component: AddProductTemplate},
  {
    path: '/product/templates/editTemplate/:id',
    exact: true,
    name: 'Edit Template',
    component: EditProductTemplate
  },
  {
    path: '/product/templates/editTemplate/:id/data-points',
    exact: true,
    name: 'Configure data points',
    component: ProductTemplateDataPointConfiguration
  },
  {
    path: '/product/templates/editTemplate/:id/enrichments',
    exact: true,
    name: 'Enrichments',
    component: ProductTemplateEnrichments
  },
  {
    path: '/product/templates/editTemplate/:id/detailed-product-view-configurations',
    exact: true,
    name: 'DetailedProductViewConfigurations',
    component: DetailedProductViewConfigTab
  },
  {
    path: '/product/templates/editTemplate/:id/meanings',
    exact: true,
    name: 'Meanings',
    component: MeaningsTab
  },
  {
    path: '/product/templates/editTemplate/:id/fieldDependencyConfig',
    exact: true,
    name: 'Field Dependency Config',
    component: FieldDependencyConfig
  },
  {
    path: '/product/prodMappingConfigs/:id',
    exact: true,
    name: 'Product Data Mappings',
    component: ProductMappingConfig
  },


  {path: '/companies', exact: true, name: 'Companies', component: Companies},


  {path: '/brands', exact: true, name: 'Brands', component: Brands},
  {path: '/brands/:id/:tab/:entityId', exact: true, name: 'Import runs', component: Brand},
  {path: '/brands/:id/:tab', exact: true, name: 'Import runs', component: Brand},
  {path: '/brands/:id', exact: true, name: 'Brand details', component: Brand},


  {path: '/retailers/', exact: true, name: 'Retailers', component: RetailerList},
  {path: '/retailers/:id', exact: true, name: 'Retailer', component: RetailerView},
  {path: '/retailers/:id/:tab', exact: true, name: 'Retailer', component: RetailerView},
  {path: '/retailer/templates', exact: true, name: 'Distribute Data Templates', component: RetailerTemplates},
  {path: '/output', exact: true, name: 'Outputs', component: RetailerTemplates},
  {path: '/output/:id', exact: true, name: 'Output', component: OutputDetailView},
  {
    path: '/retailer/templates/:id',
    exact: true,
    name: 'Distribute Data Template',
    component: RetailerDistributeDataTemplate
  },
  {path: '/retailer/templates/:id/runs', exact: true, name: 'Output runs', component: OutputRunsPage},
  {path: '/retailer/templates/runs/:id', exact: true, name: 'Specific output run', component: SpecificOutputRunPage},
  {
    path: '/retailer/templates/:outputId/tools/shopify-gql',
    exact: true,
    name: 'Shopify GraphQL Tool',
    component: ShopifyGqlToolPage
  },

  {
    path: '/retailer/templates/:id/:tab',
    exact: true,
    name: 'Distribute Data Template',
    component: RetailerDistributeDataTemplate
  },
  {
    path: '/retailer/templateMappingConfigs/:id',
    exact: true,
    name: 'Distribute Data Mapping',
    component: RetailerDistributeDataTemplateMappingConfig
  },

  {path: '/import-runs/:id/complete-missing-values', name: 'Complete missing values', component: CompleteMissingValues},
  {path: '/manual-input-hints/:tab', name: 'Manual input hints', component: ManualInputHints},
  {path: '/manual-input-hints', name: 'Manual input hints', component: ManualInputHints},
  {path: '/input/templates', name: 'Input templates', component: InputTemplateListView},
  {path: '/orders', exact: true, name: 'Orders', component: OrderListView},
  {path: '/parsers', exact: true, name: 'OCParsers', component: OCParsers},
  {path: '/orders/:id', exact: true, name: 'Order', component: OrderDetailsView},
  {path: '/order-sharing-policies', exact: true, name: 'Order Sharing Policies', component: OrderSharingPolicies},
  {path: '/order-sharing-policies/:id', exact: true, name: 'Order Sharing Policy', component: OrderSharingPolicyPage},
  {path: '/delivery-notes', exact: true, name: 'Delivery Notes', component: DeliveryNotesListPage},
  {path: '/delivery-notes/:id/items', exact: true, name: 'Delivery Note Items', component: DeliveryNoteItemsListPage},
  {path: '/pipelines', exact: true, name: 'Pipelines', component: PipelineListView},
  {path: '/system/task-queues', exact: true, name: 'Task queues', component: TaskQueueStatsPage},
  {path: '/system/cluster-jobs-overview', exact: true, name: 'Cluster jobs', component: ClusterJobsOverviewPage},
  {path: '/system/dev-snapshots', exact: true, name: 'EntityLog', component: DevSnapshots},
  {path: '/edi', exact: true, name: 'EDI', component: EdiMain},
  {path: '/edi/configuration', exact: true, name: 'EDI', component: EdiConfiguration},
  {path: '/edi/messages', exact: true, name: 'EDI', component: EdiMessages},
  {path: '/system/direct-outputs', exact: true, name: 'Direct outputs', component: DirectOutputsListPage},
  {path: '/system/direct-outputs/:id', exact: true, name: 'Direct outputs', component: DirectOutputDetailsPage},
  {path: '/system/outputs/sales-data-push-pipelines', exact:true, name: 'Sales data push pipelines', component: SalesDataPushPipelinesPage},
  {path: '/system/outputs/sales-data-push-pipelines/:id/runs', exact:true, name: 'Sales data push runs', component: SalesDataPushRunsPage},
  {path: '/system/outputs/inventory-data-push-pipelines', exact:true, name: 'Inventory data push pipelines', component: InventoryDataPushPipelinesPage},
  {path: '/system/outputs/inventory-data-push-pipelines/:id/runs', exact:true, name: 'Inventory data push runs', component: InventoryDataPushRunsPage},

  {path: '/system/integrations/google', exact: true, name: 'Google Drive', component: GoogleOAuthConfigView},
  {path: '/oauth/callback/google', exact: true, name: 'Google Oauth Callback', component: GoogleOAuthView},
  {path: '/business-intelligence', exact: true, name: 'Business Intelligence', component: BusinessIntelligencePage},
  {path: '/business-intelligence/run-states', exact: true, name: 'Run states', component: BusinessIntelligenceRunStatesPage},
  {path: '/business-intelligence/ai-usage', exact: true, name: 'AI usage', component: BusinessIntelligenceAiUsagePage},
  {path: '/business-intelligence/eos-kpis', exact: true, name: 'EOS KPIs', component: BusinessIntelligenceEosKpisPage},
  {path: '/system/magasin-ftp-images', exact: true, name: 'Magasin', component: MagasinFtpRootPage},
  {path: '/system/magasin-ftp-images/config', exact: true, name: 'Magasin', component: MagasinFtpProcessingPage},
  {path: '/system/magasin-ftp-images/usage', exact: true, name: 'Magasin', component: MagasinFtpUsage},
  {
    path: '/system/magasin-ftp-images/tools/single-process',
    exact: true,
    name: 'Magasin',
    component: MagasinToolSingleImageProcessing
  },
  {path: '/system/magasin-ftp-images/history', exact: true, name: 'Magasin History', component: MagasinHistory},
  {
    path: '/tools/simulate-extract-data-with-ai',
    exact: true,
    name: 'Simulate extract data with AI',
    component: SimulateExtractDataWithAiPage
  },
  {path: '/reports', exact: true, name: 'Reports', component: ReportsListPage},
  {path: '/reports/:id', exact: true, name: 'Report details', component: ReportDetailsPage},
  {path: '/salesdata/metrics', exact: true, name: 'Barcode Metrics', component: BarcodeMetricsPage},
];

export default routes;
